import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : domain parts
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Table } from 'semantic-ui-react';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import { funcPart } from 'uix/parts';
import log from 'uix/logging';
import { mapItems, items, size, values, get } from 'ldash';
import { Link } from 'uix/components';
import { useSelector } from 'uix/hooks';
import { DomainIcon } from 'uix/domain/icon';
// ---Globals
export const TestDomains = funcPart({}, ({ go, i18n })=>{
    let domains = useSelector(Sel.domains);
    let buildDomain = (data)=>{
        if (data.isGhost) {
            return /*#__PURE__*/ _jsx("span", {
                style: {
                    paddingLeft: '0.3em',
                    color: 'grey'
                },
                children: data.description
            });
        } else {
            return /*#__PURE__*/ _jsx(Link, {
                dname: data.name,
                children: data.description
            });
        }
    };
    let rows = mapItems(domains.data, (k, v)=>/*#__PURE__*/ _jsxs(Table.Row, {
            children: [
                /*#__PURE__*/ _jsx(Table.Cell, {
                    children: v.id
                }),
                /*#__PURE__*/ _jsxs(Table.Cell, {
                    style: {
                        paddingLeft: `${v.level}em`
                    },
                    children: [
                        /*#__PURE__*/ _jsx(DomainIcon, {
                            dname: v.name
                        }),
                        buildDomain(v)
                    ]
                }),
                /*#__PURE__*/ _jsx(Table.Cell, {
                    children: k
                }),
                /*#__PURE__*/ _jsx(Table.Cell, {
                    children: k != v.routingPrefix ? v.routingPrefix : ''
                }),
                /*#__PURE__*/ _jsx(Table.Cell, {
                    children: i18n.getType('domain', v.type)
                })
            ]
        }, k));
    return /*#__PURE__*/ _jsxs(Table, {
        celled: true,
        compact: true,
        size: "small",
        id: "domains",
        children: [
            /*#__PURE__*/ _jsx(Table.Header, {
                children: /*#__PURE__*/ _jsxs(Table.Row, {
                    children: [
                        /*#__PURE__*/ _jsx(Table.HeaderCell, {
                            children: "ID"
                        }),
                        /*#__PURE__*/ _jsx(Table.HeaderCell, {
                            children: "Description"
                        }),
                        /*#__PURE__*/ _jsx(Table.HeaderCell, {
                            children: "Name"
                        }),
                        /*#__PURE__*/ _jsx(Table.HeaderCell, {
                            children: "Routing"
                        }),
                        /*#__PURE__*/ _jsx(Table.HeaderCell, {
                            children: "Type"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Table.Body, {
                children: rows
            })
        ]
    });
});
